import { useEffect, useRef, useState, useContext } from "react";
import useDB from "../../../hooks/useDB";
import Loading from "../../../components/Loading";
import Error from "../../../components/Error";
import "./days.css"
import { useNavigate } from "react-router-dom";
import Weekday from "../../student/components/Weekday";
import LessonMenu from "./LessonMenu";
import SwapLessons from "./SwapLessons";
import ChangeLesson from "./ChangeLesson";
import { net } from "../../../../../database";
import Loca from "../../../components/Loca";
import useCTX from "../../../hooks/useCTX";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button as MuiButton } from "@mui/material";
import { LanguageContext } from "../../../../../Context";
import Lang from "../../../components/Lang";
import { monthnames } from "../../../../../enums";
import { Calendar, ChevronLeft, ChevronRight, CalendarClock, PartyPopper, Cloud, MoreVertical } from "lucide-react";
import sdate from "@timclark/sdate";






export default function Days({startOfWeek, onDataLoaded}) {
  const { language } = useContext(LanguageContext);
  const midDate = startOfWeek ? startOfWeek : new sdate().startOfWeek();
  const [lessons, setLessons, error, loading, setError, setLoading] = useDB(`/user/days/${midDate}`)
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!loading && lessons) {
      onDataLoaded?.(lessons.length);
    }
  }, [loading, lessons, onDataLoaded]);

  const refresh = async () => {
    setLoading(true);
    try {
      const l = await net.get(`/user/days/${midDate.toString()}`);
      if (l) {
        setLessons(l);
        setError(false);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  
  const fullWeekDays = get7Days(midDate);
  const activeDaysWidget = fullWeekDays.filter(day => day===new sdate().toString());

  // Formatted date for the header
  const todayDateStr = new Date().toLocaleDateString(language === 1 ? "vi-VN" : "en-US", {
    weekday: 'long', 
    month: 'long', 
    day: 'numeric'
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  return (
    <div className="home-widget schedule-widget flex flex-col overflow-hidden">
      <div className="px-6 pt-6 pb-4 border-b border-slate-100 flex justify-between items-center bg-slate-50">
        <div className="flex flex-col">
          <h3 className="text-[1.25rem] font-semibold text-slate-900 flex items-center gap-2">
            <Calendar size={22} className="text-teal-800" />
            <Lang w="todaysSchedule" />
          </h3>
          <div className="text-[0.7rem] font-black text-teal-600 uppercase tracking-widest mt-0.5">
            {todayDateStr}
          </div>
        </div>
        <button 
          className="bg-white hover:bg-slate-50 text-slate-700 font-bold py-1.5 px-4 rounded-xl text-xs border border-slate-200 shadow-sm transition-all active:scale-95 cursor-pointer"
          onClick={() => setIsModalOpen(true)}
        >
          <Lang w="viewFullWeek" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-5 bg-white">
        <div 
          style={{
            display: "flex",
            justifyContent: "center",
            minHeight: lessons.length > 0 ? 100 : 238,
          }}
        >
          {activeDaysWidget.length > 0 ? (
            activeDaysWidget.map((day) => (
              <DrawDay
                day={day}
                key={day}
                loading={loading}
                lessons={lessons
                  .filter((l) => l.tDate === day)
                  .sort((a, b) =>
                    a.startTime > b.startTime
                      ? 1
                      : b.startTime > a.startTime
                      ? -1
                      : 0
                  )}
                refresh={refresh}
                viewMode="today"
              />
            ))
          ) : (
            <div className="widget-empty">
              <PartyPopper size={32} className="widget-empty-icon" />
              <p><Lang w="noClassesToday" /></p>
              <button 
                className="widget-action-btn mt-4"
                onClick={() => setIsModalOpen(true)}
              >
                <Lang w="checkWeeklySchedule" />
              </button>
            </div>
          )}
        </div>
      </div>

      {isModalOpen && <WeeklyScheduleModal onClose={() => setIsModalOpen(false)} />}
    </div>
  );
}

function WeeklyScheduleModal({ onClose }) {
  const [modalDate, setModalDate] = useState(new sdate().startOfWeek());
  const [lessons, setLessons, error, loading, setError, setLoading] = useDB(`/user/days/${modalDate}`);

  const refresh = async () => {
    setLoading(true);
    try {
      const l = await net.get(`/user/days/${modalDate}`);
      if (l) {
        setLessons(l);
        setError(false);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const activeDaysModal = get7Days(modalDate);
  const filteredDays = (lessons || []).length > 0 
    ? activeDaysModal.filter(day => lessons.some(l => l.tDate === day))
    : [];

  if (error) return <Error />;

  return (
    <Dialog
      open={true}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        style: {
          background: "#ffffff",
          borderRadius: "24px",
          boxShadow: "0 25px 60px rgba(0, 0, 0, 0.15)",
          color: "#0f172a",
          width: '95vw',
          maxWidth: '1800px',
          height: '85vh',
          minHeight: '600px',
          margin: '24px auto',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <DialogTitle className="flex justify-between items-center border-b border-slate-200 p-6">
        <div className="flex items-center gap-4">
          <div
          style={{
               background: '#f0fdfa',
              padding: '8px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Calendar size={24} className="text-teal-800" />
          </div>
          <div>
            <div style={{ fontWeight: 800, fontSize: '1.4rem', color: '#0f172a', letterSpacing: '-0.02em' }}>
              <Lang w="weeklySchedule" />
            </div>
            <div className="text-xs font-bold text-slate-500 uppercase tracking-widest mt-0.5">
               <Lang w="managementHub" />
            </div>
          </div>
        </div>

        <WeekSelector date={modalDate} setDate={setModalDate} />

      </DialogTitle>
      <DialogContent className="p-0 bg-slate-50/30 relative flex flex-col overflow-hidden" style={{ flex: 1 }}>
        {loading && (
          <div className="absolute inset-0 z-50 bg-white/60 backdrop-blur-[1px] flex items-center justify-center">
            <Loading />
          </div>
        )}
        
        {filteredDays.length === 0 && !loading ? (
          <div className="flex flex-col items-center justify-center p-20 text-slate-400 bg-white flex-1 w-full">
            <Cloud size={48} className="mb-4 opacity-20" />
            <p className="font-bold text-slate-500 text-lg"><Lang w="noLessonsThisWeek" /></p>
            <p className="text-sm text-slate-400 mt-2"><Lang w="enjoyYourTimeOff" /></p>
          </div>
        ) : (
          <div className={`flex w-full h-full divide-x divide-slate-200/60 overflow-x-auto transition-opacity duration-300 ${loading ? 'opacity-40' : 'opacity-100'}`}>
            {filteredDays.map((day) => (
              <DrawDay
                day={day}
                key={day}
                loading={false}
                lessons={lessons
                  .filter((l) => l.tDate === day)
                  .sort((a, b) =>
                    a.startTime > b.startTime
                      ? 1
                      : b.startTime > a.startTime
                      ? -1
                      : 0
                  )}
                refresh={refresh}
                viewMode="week"
              />
            ))}
          </div>
        )}
      </DialogContent>
      <DialogActions className="border-t border-slate-200 p-5 bg-slate-50">
        <MuiButton 
          onClick={onClose}
          variant="contained"
          disableElevation
          className="cursor-pointer"
          style={{ 
            background: "#ffffff",
            color: "#0f172a",
            borderRadius: "12px",
            padding: "10px 32px",
            fontWeight: 700,
            border: "1px solid #e2e8f0"
          }}
        >
          <Lang w="close" />
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
}

function WeekSelector({ date, setDate }) {
  const { l, language } = useContext(LanguageContext);
  const weekStart = new sdate(date);

  return (
<div className="flex items-center gap-1 bg-slate-100 rounded-xl p-1 border border-slate-200 shadow-sm">
        <button
          className="p-2 hover:bg-white rounded-lg transition-colors cursor-pointer"
          onClick={() => setDate(weekStart.addDays(-7).toString())}
        >
          <ChevronLeft size={20} className="text-slate-600" />
        </button>

        <div className="text-sm font-bold text-slate-700 w-48 text-center">
          <Lang w="weekOf" /> {monthnames[weekStart.month() + 1][language]} {weekStart.date()}
        </div>

        <button
          className="p-2 hover:bg-white rounded-lg transition-colors cursor-pointer"
          onClick={() => setDate(weekStart.addDays(7).toString())}
        >
          <ChevronRight size={20} className="text-slate-600" />
        </button>

        <div className="border-l border-slate-300 mx-1 h-6"></div>

        <button
          onClick={() => setDate(new sdate().startOfWeek())}
          className="p-2 rounded-lg transition-colors cursor-pointer"
          style={{ color: '#0d9488', background: '#f0fdfa' }}
          title={l["jumpToToday"][language]}
        >
          <CalendarClock size={18} />
        </button>
      </div>
  )
}

function DrawDay(props){
  const { day, loading, lessons, refresh, viewMode } = props

  const dt = new Date(day)
  if (loading) return <Loading />
  
  let isToday = dt.isToday();
  let dayClassStr = `day-box ${isToday ? "is-today" : ""} ${viewMode === "today" ? "w-full" : ""}`;

  return (
    <div className={dayClassStr}>
      {viewMode !== "today" && (
        <div className="day-title">
            <div className="day-name">
              <Weekday id={dt.getDay()} />
            </div>
            <div className="day-date">{dt.fDateDM()}</div>
        </div>
      )}

      <div className="day-classes-container">
          {lessons.map((l, i) => (
            <DrawClass
              lesson={l}
              day={day}
              key={l._id}
              refresh={refresh}
              index={i}
            />
          ))}
        </div>
      </div>
    );
}   

function DrawClass({lesson,refresh, index}) {
 
  const navigate = useNavigate()
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);
  const [openSwap, setOpenSwap] = useState(false);
  const [openChange, setOpenChange] = useState(false);
  const suppressClick = useRef(false);
  const [contextOpened, setContextOpened] = useState(false);
  const dialogOpen = openSwap || openChange;
  const {user} = useCTX()


     
useEffect(() => {
  const handleClick = (e) => {
    if (!e.target.closest(".custom-context-menu")) {
      setVisible(false);
      if (contextOpened) {
        suppressClick.current = false;
        setContextOpened(false);
      }
    }
  };
  document.addEventListener("click", handleClick);
  return () => {
    document.removeEventListener("click", handleClick);
  };
}, [contextOpened]);

  const startTime = lesson.foreignTeacher && user._id===lesson.foreignTeacher ? lesson.FTStartTime : lesson.startTime
  const endTime =
    lesson.foreignTeacher && user._id === lesson.foreignTeacher
      ? lesson.FTEndTime
      : lesson.endTime;
  
  return (
    <>
      <div
        className="day-class"
        onClick={(e) => {
          if (e.button !== 0 || suppressClick.current || dialogOpen) return;
          navigate(`/feedback2/${lesson._id}`);
        }}
        onContextMenu={(e) => {
          e.preventDefault();
          suppressClick.current = true;
          setContextOpened(true);
          setPosition({ x: e.pageX, y: e.pageY });
          setVisible(true);
        }}
      >
        <div className="class-content">
          <div className="class-header-row">
            <div className="class-time-row">
              <span className="time-pill">
                {startTime ? startTime.substring(0, 5) : "--:--"} - {endTime ? endTime.substring(0, 5) : "--:--"}
              </span>
            </div>
            <div className="class-meta-row">
              <span className="meta-badge">
                <Loca id={lesson.location} />
              </span>
              <span className="meta-badge badge-room">
                {lesson.room}
              </span>
            </div>
          </div>
          
          <div className="class-body">
            <div className="class-name">{lesson.name}</div>
            <DrawLessonOrTest lessonOrTest={lesson.lessonOrTest} />
          </div>
        </div>


        <button
          className="class-action-btn p-1.5 hover:bg-slate-100 rounded-lg transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            suppressClick.current = true;
            setContextOpened(true);
            setPosition({ x: e.pageX, y: e.pageY });
            setVisible(true);
          }}
        >
          <MoreVertical size={16} className="text-slate-500" />
        </button>
        {openSwap && (
          <SwapLessons
            open={openSwap}
            setOpen={setOpenSwap}
            lesson={lesson}
            refresh={refresh}
          />
        )}
        {openChange && (
          <ChangeLesson
            open={openChange}
            setOpen={setOpenChange}
            lesson={lesson}
            refresh={refresh}
          />
        )}
      </div>
      {visible && (
        <div
          style={{
            position: "absolute",
            top: `${position.y}px`,
            left: `${position.x}px`,
            zIndex: 1000,
          }}
          onClick={() => setVisible(false)}
        >
          <LessonMenu
            lesson={lesson}
            setOpenSwap={setOpenSwap}
            setOpenChange={setOpenChange}
          />
        </div>
      )}
    </>
  );
}

function DrawLessonOrTest({ lessonOrTest }) {
  if (!lessonOrTest) return <></>
  
  if (lessonOrTest.type === "lesson") {
    const {lesson} = lessonOrTest
    return (
      <div className="lesson-plan-text">
        <div>
          <span className="accent"><Lang w="unit" /> {lesson.unit.unitNumber}</span> • {lesson.unit.name}
        </div>
        <div>
          <span className="accent"><Lang w="lesson" /> {lesson.lessonNumber}</span> • {lesson.name}
        </div>
      </div>
    );
  }
    
  if (lessonOrTest.type === "test") {
    const { unit } = lessonOrTest;
    const testName = unit.tests?.[0]?.name;
    return (
      <div className="lesson-plan-text">
        <div>
          <span className="accent"><Lang w="testUnit" /> {unit.unitNumber}</span> • {unit.name}
        </div>
        {testName && (
          <div className="text-xs text-slate-500 mt-0.5">{testName}</div>
        )}
      </div>
    );
  }
  return <></>
}


function get7Days(startDate) {
  const startStr = startDate.toString();
  const days = [startStr];
  for (let i = 1; i < 7; i++){
    let dt = new sdate(startStr)
    dt = dt.addDays(i)
    days.push(dt.toString())
  }
  return days;
}
